import {
  // Stack,
  Paper,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TablePagination,
  Grid,
} from "@mui/material";

export default function SortDialog(props) {
  return (
    <Paper elevation={6} style={{ width: "100%", marginBottom: 20 }}>
      <div style={{ margin: 6, width: "100%" }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              <InputLabel id="demo-simple-select-label">Sort by</InputLabel>
              <Select
                size="small"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Sort by"
                // IconComponent="FilterList"
                value={props.sortByValue}
                onChange={(e) =>
                  props.onSortChange(e.target.value, props.objArray)
                }
              >
                {props.sortByOptions.map((op) => (
                  <MenuItem value={op}>{op}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ m: 1, minWidth: 120 }}>
              <TextField
                id="outlined-search"
                label="Search"
                type="search"
                size="small"
                value={props.filterValue}
                onChange={(e) => props.onFilterChange(e.target.value)}
              />
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TablePagination
              style={{ paddingRight: 16 }}
              component="div"
              count={props.objArray.length}
              page={props.page}
              rowsPerPageOptions={[5, 10, 20, 40]}
              onPageChange={props.handleChangePage}
              rowsPerPage={props.rowsPerPage}
              labelRowsPerPage="rows:"
              onRowsPerPageChange={props.handleChangeRowsPerPage}
            />
          </Grid>
        </Grid>
      </div>
    </Paper>
  );
}
